export default async function selectPassengersFormSet({
  passengersForm,
  chosenSeats,
  statement,
  returnWay = false,
}) {
  passengersForm.setFieldValue('passengers', chosenSeats?.map((seat) => {
    const statementSeat = statement.statementRides[returnWay ? 1 : 0].statementSeats.find(
      (stateSeat) => +stateSeat.seatNumber === +seat.seat_number
              && +stateSeat.carriageId === +seat.carriage_id,
    );
    return ({
      seat_number: seat?.seat_number,
      carriage_id: seat?.carriage_id,
      carriage_order_number: statementSeat?.carriage?.carriageOrderNumber,
      carriage_index: statementSeat.carriageOrderNumber,
      initial_seat_price: statementSeat?.paymentAmount,
      seat_class: seat?.seat_class,
      seat_id: statementSeat.id,
      seat_group_property_id: seat?.seat_group_property_id,
      seat_group_property_item_id: seat?.seat_group_property_item_id,
    });
  }));
}
